import moment from "moment";
import ParticipantsTooltip from "./ParticipantsTooltip";
import { useTranslation } from "react-i18next";
import { Box, Icon, IconButton } from "@mui/material";

const LastServiceCard = ({ service, isFirst }) => {
  const { t } = useTranslation();

  const ServiceTimeBadge = ({ label, color }) => (
    <Box
      sx={{
        minWidth: 15,
        height: 15,
        borderRadius: "50%",
        backgroundColor: color,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.6rem",
        lineHeight: 1,
        mr: 0.2,
      }}
    >
      {label}
    </Box>
  );
  return (
    <div className="card-last-service">
      <div className="header">
        <div
          style={{
            backgroundColor: service.status.color.background,
            color: service.status.color.font,
          }}
          className="status"
        >
          {service.status.name}
        </div>
        <div>{service.index}</div>
        <div>
          {moment(service.plannedServiceDateTime).isValid() && (
            <>
              <ServiceTimeBadge
                label="P"
                color="var(--BMX-warning)" // niebieski
              />
              {moment(service.plannedServiceDateTime).format(
                "DD/MM/YYYY HH:mm",
              )}
            </>
          )}
        </div>

        <div>
          {moment(service.startDateTime).isValid() && (
            <>
              <IconButton
                disabled
                style={{
                  width: 15,
                  height: 15,

                  color: "#fff",
                  backgroundColor: "var(--BMX-primary)",
                  borderRadius: "50%",
                }}
              >
                <Icon style={{ fontSize: 10 }}>play_arrow</Icon>
              </IconButton>
              {moment(service.startDateTime).format("DD/MM/YYYY HH:mm")}
            </>
          )}
        </div>

        <div>
          {moment(service.endDateTime).isValid() && (
            <>
              <IconButton
                disabled
                style={{
                  width: 15,
                  height: 15,

                  color: "#fff",
                  backgroundColor: "var(--BMX-error)",
                  borderRadius: "50%",
                }}
              >
                <Icon style={{ fontSize: 10 }}>stop</Icon>
              </IconButton>
              {moment(service.endDateTime).format("DD/MM/YYYY HH:mm")}
            </>
          )}
        </div>

        <div>
          <ParticipantsTooltip
            leader={service.technicianOrTeamLeader}
            others={service.techniciansInTheGroup}
          />
        </div>
      </div>

      {isFirst && (
        <div style={{ marginTop: "10px" }} className="section">
          <div className="label">
            {t("global:service.problemDescriptionsDictionary")}:
          </div>
          <div className="text">
            {service?.problemDescriptionsDictionary
              ?.map((p) => p.entryName)
              .filter(Boolean)
              .join(" • ")}
          </div>
        </div>
      )}

      {isFirst && (
        <div className="section">
          <div className="label">{t("global:service.tasksDictionary")}:</div>
          <div className="text">
            {service?.tasksDictionary
              ?.map((p) => p.entryName)
              .filter(Boolean)
              .join(" • ")}
          </div>
        </div>
      )}

      {isFirst && (
        <div className="section">
          <div className="label">
            {t("global:service.additionalLogisticsDescription")}:
          </div>
          <div className="text">{service?.additionalLogisticsDescription}</div>
        </div>
      )}

      <div className="section">
        <div className="label">{t("global:service.interventionScope")}:</div>
        <div className="text">{service?.interventionScope}</div>
      </div>

      <div className="section">
        <div className="label">
          {t("global:service.technicianNotesNextIntervention")}:
        </div>
        <div className="text">{service?.technicianNotesNextIntervention}</div>
      </div>
      <div className="grid-spacer-grey" />
    </div>
  );
};

export default LastServiceCard;
